import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import useApi from "../../services/useApi";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import ObjectBuilder from "../../components/commonfunctions/ObjectBuilder";
import { convertTimestamp } from "../../components/commonfunctions/convertDate";
import ShimmerLoader from "./components/ViewManulaShimmer";
import Image from "../../components/images/Image";
import config from "../../config/config";


export default function ViewManual() {
    const { getAPI } = useApi();
    const [loading, setLoading] = useState(false);
    const { id, purchaseId } = useParams();
    const navigate = useNavigate();
    const detailsRef = useRef<HTMLDetailsElement>(null);
    const divRef = useRef<HTMLDivElement | null>(null);
    const pathname = useSelector((state: RootState) => state.geolocation.previousUrl);
    const url = useSelector((state: RootState) => state.geolocation.mnoUrl);

    const [manualEntryDetails, setManualEntryDetails] = useState({
        "transaction_id": "",
        "purchase_type": "",
        "purchased_date": "",
        "purchased_amount": "",
        "note": "",
        "created_at": "",
        "receipt_url": ""
    });
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                detailsRef.current &&
                !detailsRef.current.contains(event.target as Node)
            ) {
                detailsRef.current.open = false;
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    /**
     * This function fetches details of a master distributor from an API and updates the state accordingly,
     * handling errors and navigation based on the response.
     */
    const fetchManualEntryDetails = async () => {
        setLoading(true);
        try {
            const response = await getAPI(`manual-entries/purchases/${purchaseId}`);
            if (!response?.error) {
                let details = ObjectBuilder(manualEntryDetails, response?.data?.data);
                setManualEntryDetails(details)
            } else {
                navigate("/not-found", {
                    state: { route: "/admin-management/list-of-admins" },
                });
            }
        } catch (error) {
            console.error("Error fetching admin details:", error);
        }
        setLoading(false);
    };

    useLayoutEffect(() => {
        fetchManualEntryDetails();
    }, []);

    return (
        <div>
            <Breadcrumbs
                navPath={[`MNO Management`, `List of MNO's`, `View Details`, 'List of Purchased Amount Transaction', 'View Purchased Amount Transaction']}
                links={pathname ? [pathname, pathname, `/mno-management/list-of-mnos/view-mno/${id}`,url ? url : 'back'] : [`/mno-management/list-of-mnos`, `/mno-management/list-of-mnos`, `/mno-management/list-of-mnos/view-mno/${id}`, url ? url : 'back']}
                heading={`View Purchased Amount Transaction`}
            />

            {!loading ? (
                <div className=" px-4 py-4 mt-1.5 bg-white h-maintableheight2 rounded-lg flex flex-col" ref={divRef}>
                    <div className="flex flex-wrap">
                        <div className="w-1/3 mb-4">
                            <h1 className="text-body2">Transaction ID</h1>
                            <p className="text-body1" data-testid="transaction_id">{manualEntryDetails?.transaction_id || '-'}</p>
                        </div>
                        <div className="w-1/3 mb-4">
                            <h1 className="text-body2">Purchased Date</h1>
                            <p className="text-body1" data-testid="purchase_date">{manualEntryDetails?.purchased_date || '-'}</p>
                        </div>
                        <div className="w-1/3 mb-4">
                            <h1 className="text-body2">Processed Date & Time</h1>
                            <p className="text-body1" data-testid="processed_date">{manualEntryDetails?.created_at ? convertTimestamp(manualEntryDetails?.created_at) : '-'}</p>
                        </div>
                        <div className="w-1/3 mb-4">
                            <h1 className="text-body2">Purchased Amount</h1>
                            <p className="text-body1" data-testid="purchase_amount">{manualEntryDetails?.purchased_amount || '-'}</p>
                        </div>
                        <div className="w-1/3 mb-4">
                            <h1 className="text-body2">Purchase Type</h1>
                            <p className="text-body1" data-testid="purchase_type">{manualEntryDetails?.purchase_type || '-'}</p>
                        </div>
                        <div className="w-1/3 mb-4">
                            <h1 className="text-body2">Transaction Receipt</h1>
                            {manualEntryDetails?.receipt_url ? <div
                                className="w-[68%] flex justify-between gap-1 overflow-hidden text-ellipsis py-[15px] px-[18px] bg-outline mt-2 rounded-[8px] text-body1"
                            >
                                <p className="more-lines text-body1">{manualEntryDetails?.receipt_url?.split("/").pop() || manualEntryDetails?.receipt_url }</p>
                                <Image src="file-eye" className="cursor-pointer" objectFit={'contain'} onClick={() => {
                                    const fileUrl = config?.cdnURL + 'public/' + manualEntryDetails?.receipt_url;
                                    window.open(fileUrl, "_blank");
                                }} />
                            </div> : <p className="mt-1 font-medium text-gray-900">-</p>}
                        </div>
                    </div>
                    <div>
                        <div className="w-[90%] mb-4">
                            <h1 className="text-body2">Note</h1>
                            <p className="text-body1 text-justify break-words">{manualEntryDetails?.note || '-'}</p>
                        </div>
                    </div>
                </div>

            ) : (
                <ShimmerLoader />
            )}
        </div>
    );
}